'use client';
import { AwsRum, AwsRumConfig } from 'aws-rum-web';
import React, { useEffect, useRef } from 'react';
// import { useGetUserQuery } from '../api';

export const CloudWatchRumProvider = ({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) => {
  // const { data: user } = useGetUserQuery();
  const rumRef = useRef<AwsRum | null>(null);

  useEffect(() => {
    // Initialize CloudWatch RUM only once
    if (rumRef.current) return;

    try {
      const APPLICATION_ID: string = process.env.NEXT_PUBLIC_CLOUDWATCH_RUM_APP_ID!;
      const APPLICATION_VERSION: string = process.env.NEXT_PUBLIC_CLOUDWATCH_RUM_APP_VERSION || '1.0.0';
      const APPLICATION_REGION: string = process.env.NEXT_PUBLIC_AWS_REGION || 'us-east-1';

      console.log('Initializing CloudWatch RUM with:', {
        APPLICATION_ID,
        APPLICATION_VERSION,
        APPLICATION_REGION,
      });

      const config: AwsRumConfig = {
        sessionSampleRate: 1,
        endpoint: `https://dataplane.rum.${APPLICATION_REGION}.amazonaws.com`,
        telemetries: ['performance', 'errors', 'http'],
        allowCookies: true,
        enableXRay: false,
        signing: false,
      };

      const awsRum: AwsRum = new AwsRum(
        APPLICATION_ID,
        APPLICATION_VERSION,
        APPLICATION_REGION,
        config
      );

      rumRef.current = awsRum;
      console.log('CloudWatch RUM initialized successfully');
    } catch (error) {
      console.error('CloudWatch RUM initialization failed', error);
    }
  }, []);

  // Commenting out user identification temporarily to restore basic RUM functionality
  // useEffect(() => {
  //   // Add user metadata when user is available
  //   if (!user || !rumRef.current) return;

  //   try {
  //     console.log('Adding user identification to CloudWatch RUM');

  //     // Add session attributes with user information
  //     // The 'userId' attribute is used by CloudWatch RUM to identify users
  //     rumRef.current.addSessionAttributes({
  //       userId: user.userId,
  //       userEmail: user.userEmail,
  //       userName: `${user.firstName} ${user.lastName}`,
  //       userType: user.userType,
  //       orgId: user.orgId,
  //       orgName: user.orgName,
  //     });

  //     console.log('User identification added successfully:', {
  //       userId: user.userId,
  //       userEmail: user.userEmail,
  //       userName: `${user.firstName} ${user.lastName}`,
  //     });
  //   } catch (error) {
  //     console.error('CloudWatch RUM user identification failed', error);
  //   }
  // }, [user]);

  return <>{children}</>;
};
